module.exports = __webpack_public_path__ + "img/60.ee41efb1.jpg";